/**
 * Wire types of core's encryption key rotation API
 * (`/api/v1/admin/providers/encryption-key`), camelCase as core sends them.
 */

export type RotationPhase = "switch" | "reencrypt" | "verify" | "retire";
export const ROTATION_PHASES: RotationPhase[] = ["switch", "reencrypt", "verify", "retire"];

export type RotationStatus = "running" | "waiting" | "failed" | "done" | "rolled_back";

/** GET /status */
export interface EncryptionKeyStatus {
  /** 8-hex-digit SHA-256 prefix of the primary key; never the key. */
  fingerprint: string;
  keysInParameter: 1 | 2;
  lastRotation: { id: string; finishedAt: string; by: string | null } | null;
  running: { id: string; phase: RotationPhase; startedAt: string } | null;
}

export interface DatasetProgress {
  total: number;
  rotated: number;
  alreadyCurrent: number;
  failed: number;
}

/** GET /rotations/{id}; also returned by resume and rollback. */
export interface Rotation {
  id: string;
  phase: RotationPhase;
  status: RotationStatus;
  /** End of the current wait (phase 1), ISO; `null` when not waiting. */
  waitingUntil: string | null;
  datasets: {
    credentials: DatasetProgress;
    pii: DatasetProgress;
    sharepoint: DatasetProgress;
  };
  errors: Array<{ message: string; dataset?: string | null; phase?: RotationPhase | null }>;
}

/** POST /rotations body; 202 `{id}`, 409 when one runs, 412 without the confirmation. */
export interface RotationStart {
  confirmPrerequisites: boolean;
}
